package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLCanvasElement
import waldo.sankan.lineamunicipalkmp.model.TipificacionesRepositoryCEAD
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import kotlin.js.Date
import kotlin.js.json
import kotlin.math.roundToInt

// --- FUNCIONES DE AYUDA PROBADAS EN COMBATE ---
private fun Int.percentOf(total: Int): Int {
    if (this <= 0 || total <= 0) return 0
    return (this.toDouble() / total * 100).roundToInt()
}
private fun formatDurationFromMs(ms: Double): String {
    if (ms <= 0) return "N/A"
    val totalSeconds = ms / 1000
    val totalMinutes = totalSeconds / 60
    val totalHours = totalMinutes / 60
    val days = (totalHours / 24).toInt()
    val hours = (totalHours % 24).toInt()
    val minutes = (totalMinutes % 60).toInt()
    val parts = mutableListOf<String>()
    if (days > 0) parts.add("$days d")
    if (hours > 0) parts.add("$hours h")
    if (minutes > 0 || parts.isEmpty()) parts.add("$minutes min")
    return parts.joinToString(" ")
}
@Composable
private fun StatCard(label: String, value: String, color: CSSColorValue = Color.black) {
    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); padding(16.px) } }) {
        Span({ style { fontSize(28.px); fontWeight("bold"); color(color) } }) { Text(value) }
        Span({ style { fontSize(14.px); color(Color("#666666")) } }) { Text(label) }
    }
}

@Composable
private fun EstadisticasGeneralesFilterSection(
    uiState: AdminPanelUiState,
    onBack: () -> Unit,
    viewModel: AdminPanelViewModel
) {
    // Variables de estado locales para manejar los inputs de fecha
    var fechaInicioStr by remember { mutableStateOf("") }
    var fechaFinStr by remember { mutableStateOf("") }
    val rol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()

    Div({
        style {
            display(DisplayStyle.Flex);
            flexDirection(FlexDirection.Column);
            gap(16.px);
            padding(12.px);
            backgroundColor(Color.white);
            borderRadius(12.px);
            marginBottom(12.px);
            property("box-shadow", "0 4px 6px rgba(0,0,0,0.05)");
            boxSizing("border-box");
        }
    }) {

        // --- FILA 1: FILTROS (Compactada para una sola fila) ---
        Div({
            style {
                display(DisplayStyle.Flex);
                flexDirection(FlexDirection.Row);
                gap(16.px);
                alignItems(AlignItems.Center);
                property("flex-wrap", "nowrap"); // Forzamos una fila
                width(100.percent);
                padding(12.px, 12.px);
                boxSizing("border-box");
            }
        }) {

            if (rol == "GENERAL") {
                FilterDropdown(
                    label = "Regi\u00F3n:",
                    selectedValue = uiState.filtroRegionEstadisticas ?: "TODAS",
                    options = listOf("TODAS") + uiState.regiones.map { it.nombre },
                    onValueChanged = { viewModel.onFiltroRegionEstadisticasChanged(it) },
                    optionDisplayNames = (listOf("TODAS" to "Todas") + uiState.regiones.map { it.nombre to it.nombre }).toMap()
                )

                val comunasAMostrar = if (uiState.filtroRegionEstadisticas != null && uiState.filtroRegionEstadisticas != "TODAS") {
                    uiState.comunas.filter { it.regionDisplayName == uiState.filtroRegionEstadisticas }
                } else {
                    uiState.comunas
                }

                FilterDropdown(
                    label = "Comuna:",
                    selectedValue = uiState.filtroComunaEstadisticas ?: "TODAS",
                    options = listOf("TODAS") + comunasAMostrar.map { it.comunaDisplayName },
                    onValueChanged = { viewModel.onFiltroComunaEstadisticasChanged(it) },
                    optionDisplayNames = (listOf("TODAS" to "Todas") + comunasAMostrar.map { it.comunaDisplayName to it.comunaDisplayName }).toMap()
                )
            }

            FilterDropdown(
                label = "Per\u00EDodo:",
                selectedValue = uiState.filtroMesEstadisticasGenerales,
                options = listOf("ANUAL") + uiState.mesesDisponibles,
                onValueChanged = { viewModel.onFiltroMesEstadisticasGeneralesChanged(it) },
                optionDisplayNames = (listOf("ANUAL" to "Anual") + uiState.mesesDisponibles.map {
                    val (year, month) = it.split("-")
                    it to Date(year.toInt(), month.toInt() - 1).toLocaleString("es-CL", options = js("{'month': 'short', 'year': 'numeric'}")).capitalize()
                }).toMap()
            )

            Div({ style { width(1.px); height(24.px); backgroundColor(Color("#CCC")); margin(0.px, 4.px) } })

            B({ style { fontSize(14.px); whiteSpace("nowrap") } }) { Text("Rango:") }

            Input(type = InputType.Date) {
                id("fechaInicio")
                value(fechaInicioStr)
                onInput { fechaInicioStr = it.value }
                style { padding(4.px); borderRadius(4.px); border(1.px, LineStyle.Solid, Color("#cccccc")); fontSize(13.px) }
            }
            Text("-")
            Input(type = InputType.Date) {
                id("fechaFin")
                value(fechaFinStr)
                onInput { fechaFinStr = it.value }
                style { padding(4.px); borderRadius(4.px); border(1.px, LineStyle.Solid, Color("#cccccc")); fontSize(13.px) }
            }

            Button(attrs = {
                onClick {
                    if (fechaInicioStr.isNotBlank() && fechaFinStr.isNotBlank()) {
                        val fechaInicioDouble = Date.parse("${fechaInicioStr}T00:00:00.000Z")
                        val fechaFinDouble = Date.parse("${fechaFinStr}T23:59:59.999Z")
                        viewModel.onFiltroRangoFechasChanged(fechaInicioDouble, fechaFinDouble)
                    }
                }
                style {
                    padding(10.px, 20.px);
                    fontSize(14.px);
                    fontWeight("bold");
                    color(Color.white);
                    backgroundColor(if (fechaInicioStr.isBlank() || fechaFinStr.isBlank()) Color.gray else Color("#FB8C00"));
                    borderRadius(8.px);
                    cursor("pointer");
                    border(0.px);
                    whiteSpace("nowrap")
                }

                if (fechaInicioStr.isBlank() || fechaFinStr.isBlank()) { disabled() }
            }) {
                Text("Aplicar")
            }
        }

        // --- FILA 2: ACCIONES ---
        Div({
            style {
                display(DisplayStyle.Flex);
                flexDirection(FlexDirection.Row);
                gap(10.px);
                flexWrap(FlexWrap.Wrap);
                property("border-top", "1px solid #EEE");
                paddingTop(16.px);
                justifyContent(JustifyContent.FlexEnd);
                width(100.percent)
            }
        }) {

            if (rol == "COMUNAL") {
                Button(attrs = {
                    onClick { viewModel.onShowEstadisticasSeguridadClicked(forzarServiciosUrbanos = false) }
                    style {
                        padding(10.px, 20.px);
                        fontSize(14.px);
                        fontWeight("bold");
                        color(Color.white);
                        backgroundColor(Color("#303f9f"));
                        borderRadius(8.px);
                        cursor("pointer");
                        border(0.px)
                    }
                }) {
                    Text("Estad\u00EDsticas Seguridad")
                }
                Button(attrs = {
                    onClick { viewModel.onShowEstadisticasSeguridadClicked(forzarServiciosUrbanos = true) }
                    style {
                        padding(10.px, 20.px);
                        fontSize(14.px);
                        fontWeight("bold");
                        color(Color.white);
                        backgroundColor(Color("#AD1457"));
                        borderRadius(8.px);
                        cursor("pointer");
                        border(0.px)
                    }
                }) {
                    Text("Estad\u00EDsticas Servicios Urbanos")
                }
            }

                // Botón de Exportación PDF
                Button(attrs = {
                    onClick {
                        js("""
                            var jsPDF = window.jspdf.jsPDF;
                            var doc = new jsPDF('p', 'mm', 'a4');
                            var element = document.getElementById('contenido-estadisticas-generales');
                            
                            html2canvas(element, {
                                scale: 2,
                                useCORS: true,
                                logging: false,
                                backgroundColor: '#1976D2'
                            }).then(function(canvas) {
                                var imgData = canvas.toDataURL('image/png');
                                var imgProps = doc.getImageProperties(imgData);
                                var pdfWidth = doc.internal.pageSize.getWidth();
                                var pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                                
                                var heightLeft = pdfHeight;
                                var position = 0;
                                
                                doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                                heightLeft -= doc.internal.pageSize.getHeight();
                                
                                while (heightLeft >= 0) {
                                    position = heightLeft - pdfHeight;
                                    doc.addPage();
                                    doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                                    heightLeft -= doc.internal.pageSize.getHeight();
                                }
                                
                                doc.save('Estadisticas_Generales_LineaMunicipal.pdf');
                            });
                        """)
                    }
                    style {
                        padding(10.px, 20.px);
                        fontSize(14.px);
                        fontWeight("bold");
                        color(Color.white);
                        backgroundColor(Color("#FB8C00"));
                        borderRadius(8.px);
                        cursor("pointer");
                        border(0.px)
                    }
                }) {
                    Text("Exportar PDF")
                }

                Button(attrs = {
                    onClick { viewModel.exportarEstadisticasCSV() }
                    style {
                        padding(10.px, 20.px);
                        fontSize(14.px);
                        fontWeight("bold");
                        color(Color.white);
                        backgroundColor(Color("#00897B"));
                        borderRadius(8.px);
                        cursor("pointer");
                        border(0.px)
                    }
                }) {
                    Text("Exportar CSV")
                }

            Button(attrs = {
                onClick { onBack() }
                style {
                    padding(10.px, 20.px);
                    fontSize(14.px);
                    fontWeight("bold");
                    color(Color.white);
                    backgroundColor(Color("#FB8C00"));
                    borderRadius(8.px);
                    cursor("pointer");
                    border(0.px)
                }
            }) { Text("Volver al Panel") }
        }
    }
}


@Composable
fun EstadisticasWebScreen(
    viewModel: AdminPanelViewModel,
    onBack: () -> Unit
) {
    val uiState by viewModel.uiState.collectAsState()
    val esDao = uiState.rolAdmin?.comunaAsignadaDisplayName?.uppercase()?.contains("DAO") == true
    val labelHallazgo = if (esDao) "Hallazgo" else "Incidencia"
    val labelSolucion = if (esDao) "Resoluci\u00F3n" else "Soluci\u00F3n"
    val labelSolucionadas = if (esDao) "Resueltas" else "Solucionadas"
    val labelResumenTipo = "An\u00E1lisis por Tipo de $labelHallazgo"
    val labelComposicionTipo = "Distribuci\u00F3n por Tipo de $labelHallazgo (%)"
    val labelCumplimientoTipo = "Cumplimiento por Tipo de $labelHallazgo (%)"



    // --- VISTA PRINCIPAL DEL PANEL (TABLA E INCIDENCIAS) ---
    Div({
        style {
            display(DisplayStyle.Flex);
            width(100.percent);
            backgroundColor(Color("#1976D2"));
            property("border-bottom", "2px solid #1565C0")
        }
    }) {
        // Logo y Título
        Div({
            style {
                width(15.percent);
                display(DisplayStyle.Flex);
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center);
                padding(24.px);
                boxSizing("border-box")
            }
        }) {
            Div({
                style {
                    display(DisplayStyle.Flex);
                    flexDirection(FlexDirection.Column);
                    alignItems(AlignItems.Center);
                    gap(8.px) } }) {
                Img(src = "logo_icon.svg",
                    attrs = {
                        style { height(120.px) } })
                H2({
                    style { fontSize(24.px);
                        color(Color.white);
                        margin(0.px);
                        property("text-shadow",
                            "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                    Span({
                        style {
                            fontWeight("normal") } })
                    { Text("Linea") }
                    Span({
                        style {
                            fontWeight("bold") } })
                    { Text("Muni") }
                }
                P(attrs = { attr("translate", "no");
                    style { fontSize(16.px);
                        color(Color("#FB8C00"));
                        fontWeight("bold");
                        letterSpacing(1.px);
                        margin(0.px) } })
                { Text("SMART CITY") }
            }
        }

        // Panel de Control y Filtros
        Div({
            style {
                width(85.percent);
                padding(16.px, 24.px);
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column);
                gap(16.px);
                boxSizing("border-box")
            }
        }) {
            val rol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
            val panelTitle = if (rol == "GENERAL") "ESTAD\u00CDSTICAS GENERALES INCIDENCIAS" else "ESTAD\u00CDSTICAS COMUNALES INCIDENCIAS"
            H1({
                style {
                    color(Color.white);
                    fontSize(32.px);
                    fontWeight(700);
                    margin(0.px);
                    paddingTop(20.px);
                    flex(1);
                    textAlign("center")
                }
            }) { Text(panelTitle) }

            EstadisticasGeneralesFilterSection(uiState = uiState, onBack = onBack, viewModel = viewModel)
        }
    }

        // --- CONTENIDO PRINCIPAL ---
        Div({
            id("contenido-estadisticas-generales") // ID para la exportación PDF
            style {
                paddingRight(32.px);
                paddingLeft(32.px);
                backgroundColor(Color("#1976D2"));
                display(DisplayStyle.Flex);
                flexDirection(FlexDirection.Column);
                gap(32.px) 
            } 
        }) {

            if (uiState.isLoading) {
                P { Text("Calculando estad\u00EDsticas...") }
            } else if (uiState.estadisticas.isEmpty()) {
                Div({
                    style {
                        padding(24.px);
                        textAlign("center");
                        backgroundColor(Color.white);
                        borderRadius(12.px) } }) {
                    P { Text("No hay datos para el per\u00EDodo seleccionado.") }
                }
            } else {
                val statsMes = uiState.estadisticas.first()
                val todosLosTipos = statsMes.desglosePorTipo
                    .sortedByDescending { it.resumen.total }

                // --- TARJETA DE RESUMEN SUPERIOR ---
                Div({
                    style {
                        color(Color("#1976D2"))
                        borderRadius(12.px);
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)") } }) {
                    H2({
                        style {
                            fontSize(24.px);
                            color(Color.white);
                            marginTop(0.px);
                            marginBottom(24.px);
                            property("border-bottom", "1px solid #e0e0e0");
                            paddingBottom(16.px) } }) {
                        Text(statsMes.mes)
                    }
                    Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceAround); alignItems(AlignItems.Center); padding(16.px); backgroundColor(Color("#fafafa")); borderRadius(8.px); marginBottom(24.px) } }) {
                        StatCard(label = "Total", value = statsMes.resumenGeneral.total.toString())
                        StatCard(label = labelSolucionadas, value = statsMes.resumenGeneral.solucionadas.toString(), color = Color("#4CAF50"))
                        StatCard(label = "En Proceso", value = statsMes.resumenGeneral.enProceso.toString(), color = Color("#FFC107"))
                        StatCard(label = "Rechazadas", value = statsMes.resumenGeneral.rechazadas.toString(), color = Color("#F44336"))
                        StatCard(label = "Verificadas", value = statsMes.resumenGeneral.verificadas.toString(), color = Color("#3F51B5"))
                        StatCard(label = "T\u00B0 Prom. $labelSolucion", value = formatDurationFromMs(statsMes.resumenGeneral.tiempoPromedioSolucionMs))
                    }
                }

                // --- FILA 1: ANÁLISIS DE CANTIDADES ---
                Div({
                    style {
                        backgroundColor(Color.white);
                        borderRadius(12.px);
                        padding(24.px);
                        property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)") } }) {
                    H2({
                        style { fontSize(22.px);
                            color(Color("#1976D2"));
                            marginTop(0.px);
                            marginBottom(24.px) } })
                    { Text(labelResumenTipo) }
                    Div({
                        style {
                            display(DisplayStyle.Flex);
                            flexDirection(FlexDirection.Row);
                            gap(24.px);
                            alignItems(AlignItems.Start) } }) {
                        // Columna Tabla (40%)
                        Div({
                            style { flexBasis(40.percent) } }) {
                            Table({
                                style { width(100.percent);
                                    property("border-collapse", "collapse");
                                    fontSize(14.px) } }) {
                                Thead({
                                    style { backgroundColor(Color("#eef2f5")) } }) {
                                    Tr {
                                        Th({ style { padding(12.px); textAlign("left") } }) { Text("Tipo de $labelHallazgo") }
                                        Th({ style { padding(12.px) } }) { Text("Total") }
                                        Th({ style { padding(12.px); color(Color("#4CAF50")) } }) { Text(labelSolucionadas) }
                                        Th({ style { padding(12.px); color(Color("#FFC107")) } }) { Text("En Proceso") }
                                        Th({ style { padding(12.px); color(Color("#F44336")) } }) { Text("Rechazadas") }
                                        Th({ style { padding(12.px); color(Color("#3F51B5")) } }) { Text("Verificadas") }
                                        Th({ style { padding(12.px); color(Color("#1976D2")) } }) { Text("T\u00B0 Prom. $labelSolucion") }
                                    }
                                }
                                Tbody {
                                    todosLosTipos.forEach { statsTipo ->
                                        Tr({ style { property("border-bottom", "1px solid #e0e0e0") } }) {
                                            Td({ style { padding(12.px); fontWeight("bold") } }) { Text(statsTipo.tipoIncidencia) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(statsTipo.resumen.total.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(statsTipo.resumen.solucionadas.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(statsTipo.resumen.enProceso.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(statsTipo.resumen.rechazadas.toString()) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text(statsTipo.resumen.verificadas.toString()) }
                                            Td({ style { padding(12.px); textAlign("center"); fontWeight("bold"); color(Color("#1976D2")) } }) {
                                                Text(formatDurationFromMs(statsTipo.resumen.tiempoPromedioSolucionMs))
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        // Contenedor de Gráficos (60%)
                        Div({ style { flexBasis(60.percent); display(DisplayStyle.Flex); gap(16.px) } }) {
                            // Columna Gráfico Torta
                            Div({ style { flex(1); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(16.px) } }) {
                                H3({ style { fontSize(18.px); color(Color("#333333")); margin(0.px) } }) { Text("Distribuci\u00F3n de Estados") }
                                Div({ style { width(100.percent); height(300.px); position(Position.Relative) } }) {
                                    Canvas(attrs = { id("pieChart-general-estados") })
                                    DisposableEffect(statsMes) {
                                        val pieCanvas = document.getElementById("pieChart-general-estados") as? HTMLCanvasElement
                                        var pieChart: Chart? = null
                                        if (pieCanvas != null) {
                                            val resumen = statsMes.resumenGeneral
                                            val data = json("labels" to arrayOf(labelSolucionadas, "En Proceso", "Rechazadas", "Verificadas"),
                                                "datasets" to arrayOf(json("data" to arrayOf(resumen.solucionadas, resumen.enProceso, resumen.rechazadas, resumen.verificadas),
                                                    "backgroundColor" to arrayOf("#4CAF50", "#FFC107", "#F44336", "#3F51B5"))))
                                            val pieOptions = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 15, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            pieChart = Chart(pieCanvas.getContext("2d"),
                                                json("type" to "pie", "data" to data, "options" to pieOptions))
                                        }
                                        onDispose { pieChart?.destroy() }
                                    }
                                }
                            }
                            
                            Div({ style { flex(1); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(16.px) } }) {
                                H3({ style { fontSize(18.px); color(Color("#333333")); margin(0.px) } }) { Text(labelComposicionTipo) }
                                Div({ style { width(100.percent); height(300.px); position(Position.Relative) } }) {
                                    Canvas(attrs = { id("barChart-general-composicion") })
                                    DisposableEffect(todosLosTipos) {
                                        val barCanvas = document.getElementById("barChart-general-composicion") as? HTMLCanvasElement
                                        var barChart: Chart? = null
                                        if (barCanvas != null) {
                                            val desglose = todosLosTipos
                                            val labels = desglose.map { it.tipoIncidencia }.toTypedArray()
                                            val data = json(
                                                "labels" to labels,
                                                "datasets" to arrayOf(
                                                    json("label" to labelSolucionadas, "data" to desglose.map { it.resumen.solucionadas }.toTypedArray(), "backgroundColor" to "#4CAF50"),
                                                    json("label" to "En Proceso", "data" to desglose.map { it.resumen.enProceso }.toTypedArray(), "backgroundColor" to "#FFC107"),
                                                    json("label" to "Rechazadas", "data" to desglose.map { it.resumen.rechazadas }.toTypedArray(), "backgroundColor" to "#F44336"),
                                                    json("label" to "Verificadas", "data" to desglose.map { it.resumen.verificadas }.toTypedArray(), "backgroundColor" to "#3F51B5")
                                                )
                                            )
                                            val barOptions = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "scales" to json("x" to json("stacked" to true), "y" to json("stacked" to true)),
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 15, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            barChart = Chart(barCanvas.getContext("2d"), json("type" to "bar", "data" to data, "options" to barOptions))
                                        }
                                        onDispose { barChart?.destroy() }
                                    }
                                }
                            }
                        }
                    }
                }


                // --- FILA 2: ANÁLISIS DE PORCENTAJES (¡40/60 LAYOUT!) ---
                Div({ style { backgroundColor(Color.white); borderRadius(12.px); padding(24.px); property("box-shadow", "0px 4px 15px rgba(0,0,0,0.08)") } }) {
                    H2({ style { fontSize(22.px); color(Color("#1976D2")); marginTop(0.px); marginBottom(24.px) } }) { Text("An\u00E1lisis por Porcentaje") }
                    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Row); gap(24.px); alignItems(AlignItems.Start) } }) {

                        // --- Columna Tabla Porcentajes (40%) ---
                        Div({ style { flexBasis(40.percent) } }) {
                            Table({ style { width(100.percent); property("border-collapse", "collapse"); fontSize(14.px) } }) {
                                Thead({ style { backgroundColor(Color("#eef2f5")) } }) {
                                    Tr {
                                        Th({ style { padding(12.px); textAlign("left") } }) { Text("Tipo de $labelHallazgo") }
                                        Th({ style { padding(12.px) } }) { Text("% del Total") }
                                        Th({ style { padding(12.px) } }) { Text("% $labelSolucionadas") }
                                        Th({ style { padding(12.px) } }) { Text("% En Proceso") }
                                        Th({ style { padding(12.px) } }) { Text("% Rechazadas") }
                                        Th({ style { padding(12.px) } }) { Text("% Verificadas") }
                                    }
                                }
                                Tbody {
                                    val totalIncidenciasDelPeriodo = statsMes.resumenGeneral.total
                                    todosLosTipos.forEach { statsTipo ->
                                        Tr({ style { property("border-bottom", "1px solid #e0e0e0") } }) {
                                            Td({ style { padding(12.px); fontWeight("bold") } }) { Text(statsTipo.tipoIncidencia) }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${statsTipo.resumen.total.percentOf(totalIncidenciasDelPeriodo)}%") }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${statsTipo.resumen.solucionadas.percentOf(statsTipo.resumen.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${statsTipo.resumen.enProceso.percentOf(statsTipo.resumen.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${statsTipo.resumen.rechazadas.percentOf(statsTipo.resumen.total)}%") }
                                            Td({ style { padding(12.px); textAlign("center") } }) { Text("${statsTipo.resumen.verificadas.percentOf(statsTipo.resumen.total)}%") }
                                        }
                                    }
                                }
                            }
                        }

                        // --- Columna Gráficos Porcentajes (60%) ---
                        Div({ style { flexBasis(60.percent); display(DisplayStyle.Flex); gap(24.px) } }) {
                            // Gráfico Torta Porcentual
                            Div({ style { flex(1); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(16.px) } }) {
                                H3({ style { fontSize(18.px); color(Color("#333333")); margin(0.px) } }) { Text(labelComposicionTipo) }
                                Div({ style { width(100.percent); height(300.px); position(Position.Relative) } }) {
                                    Canvas(attrs = { id("pieChart-general-porcentajes") })
                                    DisposableEffect(todosLosTipos) {
                                        val pieCanvas = document.getElementById("pieChart-general-porcentajes") as? HTMLCanvasElement
                                        var pieChart: Chart? = null
                                        if (pieCanvas != null) {
                                            val totalGeneral = statsMes.resumenGeneral.total
                                            val desglose = todosLosTipos
                                            val labels = desglose.map { it.tipoIncidencia }.toTypedArray()
                                            val colorPalette = arrayOf(
                                                "#4CAF50", "#FFC107", "#F44336", "#3F51B5", "#9C27B0", 
                                                "#03A9F4", "#E91E63", "#795548", "#607D8B", "#FF5722",
                                                "#CDDC39", "#009688", "#FF9800", "#673AB7", "#FFEB3B"
                                            )
                                            val backgroundColors = labels.mapIndexed { index, _ -> 
                                                colorPalette[index % colorPalette.size] 
                                            }.toTypedArray()

                                            val data = json(
                                                "labels" to labels,
                                                "datasets" to arrayOf(json(
                                                    "data" to desglose.map { it.resumen.total.percentOf(totalGeneral) }.toTypedArray(), 
                                                    "backgroundColor" to backgroundColors
                                                ))
                                            )
                                            val pieOptions = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 15, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            pieChart = Chart(pieCanvas.getContext("2d"), json("type" to "pie", "data" to data, "options" to pieOptions))
                                        }
                                        onDispose { pieChart?.destroy() }
                                    }
                                }
                            }

                            Div({ style { flex(1); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(16.px) } }) {
                                H3({ style { fontSize(18.px); color(Color("#333333")); margin(0.px) } }) { Text(labelCumplimientoTipo) }
                                Div({ style { width(100.percent); height(300.px); position(Position.Relative) } }) {
                                    Canvas(attrs = { id("barChart-general-porcentajes") })
                                    DisposableEffect(todosLosTipos) {
                                        val barCanvas = document.getElementById("barChart-general-porcentajes") as? HTMLCanvasElement
                                        var barChart: Chart? = null
                                        if (barCanvas != null) {
                                            val desglose = todosLosTipos
                                            val labels = desglose.map { it.tipoIncidencia }.toTypedArray()
                                            val data = json(
                                                "labels" to labels,
                                                "datasets" to arrayOf(
                                                    json("label" to "% $labelSolucionadas", "data" to desglose.map { it.resumen.solucionadas.percentOf(it.resumen.total) }.toTypedArray(), "backgroundColor" to "#4CAF50"),
                                                    json("label" to "% En Proceso", "data" to desglose.map { it.resumen.enProceso.percentOf(it.resumen.total) }.toTypedArray(), "backgroundColor" to "#FFC107"),
                                                    json("label" to "% Rechazadas", "data" to desglose.map { it.resumen.rechazadas.percentOf(it.resumen.total) }.toTypedArray(), "backgroundColor" to "#F44336"),
                                                    json("label" to "% Verificadas", "data" to desglose.map { it.resumen.verificadas.percentOf(it.resumen.total) }.toTypedArray(), "backgroundColor" to "#3F51B5")
                                                )
                                            )
                                            val barOptions = json(
                                                "responsive" to true,
                                                "maintainAspectRatio" to false,
                                                "scales" to json(
                                                    "x" to json("stacked" to true),
                                                    "y" to json(
                                                        "stacked" to true,
                                                        "ticks" to json("callback" to js("function(value) { return value + '%'; }"))
                                                    )
                                                ),
                                                "plugins" to json(
                                                    "legend" to json(
                                                        "position" to "bottom",
                                                        "labels" to json("padding" to 15, "usePointStyle" to true)
                                                    )
                                                )
                                            )
                                            barChart = Chart(barCanvas.getContext("2d"), json("type" to "bar", "data" to data, "options" to barOptions))
                                        }
                                        onDispose { barChart?.destroy() }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        }
    }
